var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mqtt-card",class:_vm.tone},[(_vm.title || _vm.$slots.action)?_c('div',{staticClass:"mqtt-card__header"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }